var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-input", {
    attrs: {
      clearable: true,
      align: _vm.column.align,
      "hide-underline": true,
      placeholder: "All"
    },
    on: { clear: _vm.applyFilter },
    nativeOn: {
      keydown: function($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        ) {
          return null
        }
        return _vm.applyFilter.apply(null, arguments)
      }
    },
    model: {
      value: _vm.localValue,
      callback: function($$v) {
        _vm.localValue = $$v
      },
      expression: "localValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }